// Internal modules
import type { Query } from '@/generated/graphql';
import { appStore } from '@/store';
import { apolloQuery } from '@/lib/apollo';
import { features, getLocale, getToken } from '@/lib';
import { CARD_META_QUERY, INSTALLMENT_OPTIONS_QUERY } from './graphql';
import type { ApolloQueryResult } from 'apollo-client';

const getCardMeta = (
  cardNumber: string,
  shouldGetCardCobrand: boolean,
  shouldGetCardDefinitions: boolean,
): Promise<ApolloQueryResult<Query>> => {
  const variables = {
    cardNumber,
    countryCode: getLocale().country,
    shouldGetCardCobrand,
    shouldGetCardDefinitions,
  };

  return apolloQuery({ query: CARD_META_QUERY, variables });
};

const getInstallments = (): Promise<ApolloQueryResult<Query>> | undefined => {
  // Return early if the flow is ineligible for installments
  if (features.isNotActive('isInstallmentsEligible')) {
    return;
  }

  const token = getToken();
  const { form: formState } = appStore.getState();
  const { value: cardNumber, cardType } = formState.cardNumber;
  const { country: buyerCountry } = getLocale();

  const variables = {
    buyerCountry,
    cardNumber,
    cardType,
    token,
  };

  return apolloQuery({
    query: INSTALLMENT_OPTIONS_QUERY,
    variables,
  }).then(({ data }) => {
    const { api: apiActions } = appStore.getActions();
    const { setInstallmentData } = apiActions;

    // If no installment options, the response will include 1 installment
    // option with the full payment, so response should never be empty,
    // hence safe to set installment data regardless with no guards
    setInstallmentData(data.getInstallmentsForOnboardingFlows);

    return data;
  });
};

export { getCardMeta, getInstallments };
